<!-- [コンテンツ領域] -->
<div class="l-core-contents__inner l-wrap__inner">
  <!-- [コンテンツ領域2カラム−メイン] -->
  <div class="l-core-contents__main">
    <div class="l-section">
      <div class="p-completed">
        <!-- 画面タイトル -->
        <div class="p-completed__head">
          <div class="c-completed-message">
            <h2
              class="c-completed-message__title c-completed-message__title--em c-completed-message__title--blue"
              [innerHTML]="displayTitleLabel | staticMsg"
            ></h2>
          </div>
        </div>

        <!-- 予約ヘッダ -->
        <div class="p-completed__body">
          <div class="p-completed__body-item">
            <div class="p-completed__title">
              <div class="p-completed__title-label p-completed__title-label--em p-completed__title-label--blue">
                {{ paymentInformation.beforePaymentOrder.data?.orderId }}
              </div>
              <div
                class="p-completed__title-status p-completed__title-status--em p-completed__title-status--blue"
                [innerHTML]="orderStatusLabel | staticMsg"
              ></div>
              <div class="p-completed__title-ticket">{{ travelerNumText }}</div>
            </div>
          </div>

          <!-- 次に必要なアクションボタン -->
          <asw-next-action *ngIf="pnrInfo" [pnrInfo]="pnrInfo"></asw-next-action>
          <!-- eチケット/EMDお客様控えボタン -->
          <div
            *ngIf="eTicketEmdLabel !== ''"
            class="p-completed__body-item"
            style="cursor: pointer"
            (throttleClick$)="eTicketEvent()"
            aswThrottleClick
          >
            <a class="c-next-action01" id="booking-completed-pres-link-1">
              <div class="c-next-action01__body">
                <div
                  class="c-next-action01__title c-next-action01__title--em"
                  [innerHTML]="eTicketEmdLabel | staticMsg"
                ></div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="l-section u-mt-sp-32 u-mt-tb-40 u-mt-pc-56">
      <!--手荷物ルール-->
      <asw-mybooking-baggage-rules
        *ngIf="displayBaggageRulesArea"
        [data]="mybookingBaggageRulesData"
        (clickLinkEvent)="clickLinkEvent()"
      ></asw-mybooking-baggage-rules>
    </div>

    <!-- //[l-section] -->
  </div>
  <!-- //[コンテンツ領域2カラム−メイン] -->

  <!-- [コンテンツ領域2カラム−サブ] -->
  <div *ngIf="isPC" class="l-core-contents__sub">
    <div class="p-sub-column-layout04">
      <div class="p-sub-column-layout04__body">
        <div class="p-sub-column-layout04__body-item">
          <asw-booking-completed-button-area
            (returnToAswTop)="clickGoToAswTopEvent()"
            (returnToMyBooking)="clickGoToMyBookingEvent()"
          ></asw-booking-completed-button-area>
        </div>
      </div>
    </div>
  </div>
  <!-- //[コンテンツ領域2カラム−サブ] -->
</div>
<!-- //[コンテンツ領域] -->
<!-- [コンテンツ領域2カラム−サブ-TAB/SP] -->
<asw-booking-completed-button-area
  *ngIf="!isPC"
  (returnToAswTop)="clickGoToAswTopEvent()"
  (returnToMyBooking)="clickGoToMyBookingEvent()"
></asw-booking-completed-button-area>
<!-- //[コンテンツ領域2カラム−サブ-TAB/SP] -->
